import React from "react";
import { Button } from "reactstrap";
import { UserService } from "src/services/UserService";
import { useStripe } from "@stripe/react-stripe-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

export interface StripeVerificationProps {
  cb: (data: StripeVerificationCb) => void;
}
export interface StripeVerificationCb {
  success: boolean;
}

export const pollResults = (sessionId: string, props: StripeVerificationProps, setError: any, setLoading: any): void => {
  const polling = setInterval(() => {
    UserService.getVerificationResult(sessionId)
      .then((r) => {
        // do something with this
        if (r.status === "verified") {
          // call back
          clearInterval(polling);
          props.cb({ success: true });
        } else if (r.status !== "requires_input") {
          clearInterval(polling);
          // there was an error, prompt to retry
          setError(r.reason);
          setLoading(false);
        }
        // else keep polling
        return console.log(r);
      })
      .catch((error) => {
        console.error(error);
      });
  }, 2000);
};

export const StripeVerification: React.FunctionComponent<StripeVerificationProps> = (props: StripeVerificationProps) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState();

  const stripe = useStripe();

  const handleStripeIdentity = (secret: string, session: string): void => {
    stripe
      .verifyIdentity(secret)
      .then((result) => {
        // poll for results
        if (result.error && result.error) {
          setLoading(false);
          console.error(result.error);
        } else {
          pollResults(session, props, setError, setLoading);
        }
        // eslint-disable-next-line no-useless-return
        return;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const launchVerify = (): void => {
    setError(null);
    setLoading(true);
    UserService.createVerificationSession()
      .then((session) => {
        // Show the verification modal.
        return handleStripeIdentity(session.secret, session.id);
      })
      .catch((error) => {
        if (error.err && error.err.some((e: string) => e === "refresh-session")) {
          // if 400 and refresh-session, callback as success
          props.cb({ success: true });
        }
        console.error("Error:", error);
      });
  };
  return (
    <div>
      <Button id="verify-btn" disabled={loading} color="secondary" className="verify-btn" onClick={launchVerify}>
        {loading === true && <FontAwesomeIcon icon={faCircleNotch} className="fa-spin"></FontAwesomeIcon>}
        {loading === false && <>Start Verification</>}
      </Button>
      {error && (
        <div>
          There was a problem with your input!
          <div className="alert alert-danger">{error}</div>
        </div>
      )}
    </div>
  );
};
